import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { faGaugeCircleMinus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/react';
import Content from 'assets/js/components/Content';
import { ErrorCodes } from 'constants/error-codes';
import { GivebutterAxiosError } from 'types/error';

interface RateLimitErrorBoundaryProps {
    children: ReactNode;
}

const RateLimitErrorBoundary = ({ children }: RateLimitErrorBoundaryProps) => {
    return (
        <ErrorBoundary
            onError={error => {
                if ((error as GivebutterAxiosError).response?.status !== ErrorCodes.RATE_LIMIT) {
                    throw error;
                }
            }}
            fallback={
                <Content>
                    <div className="flex flex-col items-center justify-center gap-2">
                        <FontAwesomeIcon size={'2x'} icon={faGaugeCircleMinus} />
                        <h1 className={'text-2xl font-medium'}>Too many requests.</h1>
                        <p className={'text-center'}>
                            You have reached a network rate limit. Please try back again in a few
                            minutes.
                        </p>
                    </div>
                </Content>
            }
        >
            {children}
        </ErrorBoundary>
    );
};

const handleRateLimitError = (error: Error) => {
    if ((error as GivebutterAxiosError).response?.status === ErrorCodes.RATE_LIMIT) {
        throw error;
    } else {
        Sentry.captureException(error);
    }
};

export { RateLimitErrorBoundary, handleRateLimitError };
